import { modifyState } from '~src/state';
import {
  showSidebarTab,
  handleTabAttachments,
  hideAllSidebarTabs,
} from '~src/sidebarLegacy';
import { sidebarLoaderIn } from '~src/sidebar/index';

export const magicFrameChangePersonPhoto = () => {
  modifyState('magicFrameSelectPersonPhotoActive', true);
  // Open the sidebar immediately for better perceived responsiveness
  hideAllSidebarTabs();
  showSidebarTab('allegati');
  // Show a loader in the attachments grid while fetching
  sidebarLoaderIn('.items-container-attachments-grid');
  // Then trigger data fetch/render
  handleTabAttachments();
};
